import _ from 'underscore';
import { formatMetric } from '@bingads-webui-campaign-legacy/performance-metric-formatter/index';

import { LocationData } from './types';
import { BUBBLE_MAX_RADIUS, BUBBLE_MIN_RADIUS, METRIC_STRINGS } from './const';

const bubbleColorForVNext = '#107C10';
const bubbleStrokeWidth = 1;
const fillOpacityRegular = 0.5;
// const fillOpacityHighlight = 1;

function getPushPinIcon({
  radius,
  fillOpacity,
}) {
  const strokeColor = bubbleColorForVNext;
  const fillColor = bubbleColorForVNext;
  const strokeWidth = bubbleStrokeWidth;

  return `<svg xmlns="http://www.w3.org/2000/svg" width="${radius * 2}" height="${radius * 2}">
      <circle cx="${radius}" cy="${radius}" r="${radius - strokeWidth}"
      stroke="${strokeColor}" stroke-width="${strokeWidth}" fill="${fillColor}" fill-opacity="${fillOpacity}"/>
      <circle cx="${radius}" cy="${radius}" r="${2}"
      fill="${fillColor}"/>
    </svg>`;
}

function createPushpinOption({ locationInfo }) {
  const {
    location, radius,
  } = locationInfo;

  const svg = getPushPinIcon({
    radius,
    fillOpacity: fillOpacityRegular,
  });
  // TODO: we will need this when we hook up with table view
  // const svgHighlight = getPushPinIcon({
  //   radius,
  //   fillOpacity: fillOpacityHighlight,
  // });

  return {
    location,
    // svgHighlight,
    svg,
    options: {
      anchor: { x: radius, y: radius },
      roundClickableArea: true,
    },
  };
}

const customPushpinBuilder = pinOption => ({
  Maps,
}) => {
  const location = new Maps.Location(pinOption.location.Latitude, pinOption.location.Longitude);
  const pin = new Maps.Pushpin(location, _.extend(pinOption.options, {
    anchor: new Maps.Point(pinOption.options.anchor.x, pinOption.options.anchor.y),
  }, { icon: pinOption.svg }));

  return pin;
};

export function formatLocationData({
  locationData, granularity, metric, dateRange, i18n,
}): LocationData[] {
  const maxValue = Math.abs(_.max(locationData, item => Math.abs(item[metric]))[metric]);
  return _.chain(locationData).sortBy(item => -item[metric]).map((item) => {
    const formattedValue: string = formatMetric(metric, item[metric]);
    const metricName: string = i18n.getString(METRIC_STRINGS[metric]);
    const location: { Latitude: string, Longitude: string } = { Latitude: item[granularity.latitude], Longitude: item[granularity.longitude] };
    const name: string = item[granularity.name];
    const radius: number = Math.max((item[metric] * BUBBLE_MAX_RADIUS) / maxValue, BUBBLE_MIN_RADIUS);

    const pushpinOption = createPushpinOption({
      locationInfo: {
        location,
        radius,
      },
    });
    const getCustomPushpin = customPushpinBuilder(pushpinOption);

    return {
      location,
      radius: Math.max((item[metric] * BUBBLE_MAX_RADIUS) / maxValue, BUBBLE_MIN_RADIUS),
      value: item[metric] as number,
      metricName,
      date: `${i18n.formatDate(dateRange.start)} - ${i18n.formatDate(dateRange.end)}`,
      name,
      formattedValue,
      getCustomPushpin,
    };
  })
    .first(10)
    .value();
}
